<p-dialog
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '90vw', maxWidth: '1500px' }"
  [draggable]="false"
  [resizable]="false"
  (onShow)="showDialog()"
  (onHide)="closeDialog()"
>
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">
      {{ isEditMode ? "Edit Blueprint" : "Create Blueprint" }}
    </span>
  </ng-template>

  <div class="flex flex-col gap-4">
    <div>
      <label for="blueprint-name" class="block mb-2 font-semibold">
        Blueprint Name
      </label>
      <input
        pInputText
        id="blueprint-name"
        [(ngModel)]="blueprintName"
        placeholder="Enter blueprint name"
        class="w-full"
      />
    </div>

    <div>
      <label for="blueprint-default-material" class="block mb-2 font-semibold">
        Default Material
      </label>
      <app-material-select
        id="blueprint-default-material"
        placeholder="Select default material"
        [value]="defaultMaterialId"
        (valueChange)="defaultMaterialId = $event"
        [includeInheritOption]="false"
      ></app-material-select>
    </div>

    @if (visible) {
      @let currencyCode = currencyCode$ | async;
      @let tradeStudyToolFeaturesEnabled =
        tradeStudyToolFeaturesEnabled$ | async;
      @let consumablesEnabled = consumablesEnabled$ | async;
      @let equipmentOptions = activeEquipment$ | async;
      @let consumableOptions = activeConsumables$ | async;
      <app-blueprint-item-data-editor
        [blueprint]="blueprint"
        [allBlueprints]="allBlueprints"
        [currencyCode]="currencyCode || 'GBP'"
        [tradeStudyToolFeaturesEnabled]="!!tradeStudyToolFeaturesEnabled"
        [consumablesEnabled]="!!consumablesEnabled"
        [equipmentOptions]="equipmentOptions || []"
        [consumableOptions]="consumableOptions || []"
      ></app-blueprint-item-data-editor>
    }
  </div>

  <div class="flex items-center justify-between gap-2 mt-2">
    <div class="min-h-[1.5rem]">
      @if (submitError) {
        <p-message severity="error" [text]="submitError"></p-message>
      }
    </div>

    <div class="flex gap-2">
      <p-button label="Cancel" severity="secondary" (onClick)="closeDialog()" />
      <p-button label="Save" icon="pi pi-save" (onClick)="onSubmit()" />
    </div>
  </div>
</p-dialog>
